module.exports = __webpack_public_path__ + "static/img/privacy-header.65ae6c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-header.jpg
// module id = wq7M
// module chunks = 0